import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { getCookie, removeCookie, setCookie } from '@/lib/cookies';
import { setCookiesEnabled } from '@/lib/applicationinsights';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import CookieRoundedIcon from '@mui/icons-material/CookieRounded';
import { useIsHydrated } from '@/hooks/useIsHydrated';
const oneYearFromNow = () => {
  const date = new Date();
  date.setFullYear(date.getFullYear() + 1);
  return date;
};
export function CookieBanner() {
  const $ = _c(10);
  const isHydrated = useIsHydrated();
  const [dismissed, setDismissed] = useState(false);
  const showBanner = isHydrated && !dismissed && !getCookie("cookieConsent");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setDismissed(true);
      setCookie("cookieConsent", "accepted", {
        expires: oneYearFromNow()
      });
      setCookiesEnabled(true);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleAccept = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setCookie("cookieConsent", "rejected", {
        expires: oneYearFromNow()
      });
      removeCookie("ai_user");
      removeCookie("ai_session");
      setDismissed(true);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleReject = t1;
  if (!showBanner) {
    return null;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      zIndex: 9999,
      borderWidth: 1,
      borderColor: "primary.light",
      borderRadius: 2,
      boxShadow: "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      sm: "column",
      md: "row"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      p: 3,
      justifyContent: "space-between",
      alignItems: {
        sm: "flex-start",
        md: "center"
      },
      gap: {
        sm: 2,
        md: 3
      }
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CookieRoundedIcon fontSize="inherit" sx={{
      fontSize: 64,
      color: "primary.light"
    }} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      flexShrink: 1,
      alignSelf: {
        xs: "flex-start",
        sm: "center"
      }
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Typography variant="h5" color="primary" sx={{
      mb: 1.5
    }}>Cookie Preferences</Typography>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Box sx={t6}>{t7}<Typography variant="body1" sx={{
        color: "neutral.dark"
      }}>We use cookies for essential website functionality and troubleshooting. To keep the site working, you need to allow the required cookies. You can choose to accept all cookies or just the essential ones.</Typography></Box>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Paper role="dialog" aria-modal="false" aria-label="Cookie banner" square={true} variant="outlined" tabIndex={-1} sx={t2}><Stack direction={t3} sx={t4}>{t5}{t8}<Stack direction="row" sx={{
          gap: 2,
          flexShrink: 0,
          alignSelf: {
            sm: "flex-start",
            md: "center"
          }
        }}><Button size="large" onClick={handleAccept} variant="outlined">Accept all cookies</Button><Button size="large" onClick={handleReject}>Only the required cookies</Button></Stack></Stack></Paper>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
}